<script lang="ts">
  import NavItem from './NavItem.svelte';
  import BackButton from './BackButton.svelte';
  import AdditionalNavItem from './AdditionalNavItem.svelte';

  interface Props {
    name?: string;
    list?: VerticalNavType[];
    active?: string;
    additionalNavs?: VerticalNavType[];
    onclick?: (nav: VerticalNavType) => void;
    onback?: () => void;
    onclickchildadditionalnav?: (nav: VerticalNavType) => void;
  }

  let {
    name = '',
    list = [],
    active = '',
    additionalNavs = [],
    onclick,
    onback,
    onclickchildadditionalnav
  }: Props = $props();

  const onClickBackButton = (): void => {
    onback?.();
  };

  const handleClickNav = (nav: VerticalNavType): void => {
    onclick?.(nav);
  };

  const onClickAdditionalNav = (nav: VerticalNavType): void => {
    onclickchildadditionalnav?.(nav);
  };
</script>

<div class="child-page">
  <div class="back-btn-wrap">
    <BackButton {name} onclick={onClickBackButton} />
  </div>
  <div class="child-nav-page-list" data-cy="nav-page-list">
    {#each list as nav}
      <NavItem
        {nav}
        active={active === nav.id}
        hasCount={nav.count}
        onclick={() => {
          handleClickNav(nav);
        }}
      />
    {:else}
      <div class="empty">Nothing found</div>
    {/each}

    <div class="additional-navs">
      {#each additionalNavs as nav}
        {#if !nav?.hidden}
          <AdditionalNavItem {nav} {active} onclick={() => onClickAdditionalNav(nav)} />
        {/if}
      {/each}
    </div>
  </div>
</div>

<style>
  .back-btn-wrap {
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    margin-bottom: 16px;
  }
  .additional-navs {
    margin-top: 28px;
  }
</style>
